
(function (c2, $) {
    'use strict';

  function init(formsetPrefix) {
    // For more info, see the BestPractice marker in
    // 'templates/reports/internal/custom_server_report_filters.html'
    //
    $('#filters tbody tr').formset({
      addLabel: '<span class="bi bi-plus-lg"></span> ' + gettext('Add a Filter'),
      addClass: 'btn btn-light',
      added: filterAdded,

      hideRemovedRows: true,
      showDeleteAllLink: false,

      // These 2 options allow multiple formsets on the same page.
      formCssClass: 'server-filter-form',
      // Django formset must be instantiated with same prefix value.
      prefix: formsetPrefix
    });
  }


  function filterAdded(row) {
      var $row = $(row);

      setupFieldStylesAndBehaviors($row);
  }


  function setupFieldStylesAndBehaviors($row) {
    // Enable any dynamic behaviors on those new fields now
    // Wire the v5 date / date-time picker on any date fields in this new row.
    if ($.bs5DateTimePicker) {
        $.bs5DateTimePicker.autoInit($row[0]);
    }

    // Style plain input field with Bootstrap styles
    $row.find('input').addClass('form-control');

    // Selectize dropdowns
    $row.find('td select').each(function() {
      c2.selectize($(this));
    });

    // Initialize range slider in the values cell as a linked slider+number pair
    var $rangeInput = $row.find('td.values input[type="range"]');
    if ($rangeInput.length) {
      c2.sliders.init($rangeInput);
    }
  }


  function reloadFormOnAttrChange(formURL) {
    $('#filters').on('change', 'td.attr select', function(e) {
      // Load this filter form again; this time `attr` has a value so
      // the form's __init__ will determine the widget and choices for
      // `values` field, if any.
      var attr = $(this).val();
      if (attr === undefined) {
        return;
      }

      var $row = $(this).closest('tr');
      $row.addClass('loading');
      c2.spinners.showInlineSpinner({element: $row});

      $.get(formURL, {'attr': attr}, function(result) {
        replaceField($row, 'td.operator', result.operator);
        replaceField($row, 'td.values', result.values);

        setupFieldStylesAndBehaviors($row);
        c2.spinners.hideInlineSpinner({element: $row[0]});
        $row.removeClass('loading');


      }).fail(function(response) {
        $row.html('<td colspan=4 class=error>' + gettext('Something went wrong. Please try again.') + '</td>');
        c2.spinners.hideInlineSpinner({element: $row[0]});
        $row.removeClass('loading');
      });
    });
  }


  function replaceField($row, cellSelector, newFieldHtml) {
    var $cell = $row.find(cellSelector);
    var $old = $cell.find('input,select');
    var $new = $(newFieldHtml);
    $new.attr('id', $old.attr('id'));
    $new.attr('name', $old.attr('name'));
    $cell.html($new);
  }

  function handleResponse(response) {
      if (response.table) {
          var $table = $(response.table);
          $('#report-container').html($table);
      } else if (response.export) {
          c2.downloads.startDownloadFromContent(response.export, response.filename);
      } else if (response.error) {
          c2.alerts.addGlobalAlert(response.error, 'error', true);
      } else if (response.errors) {
          _.forEach(response.errors, function (errors, index) {
              c2.alerts.addGlobalAlert(errors, 'error', true);
              console.log('index: ', index);
              console.log('errors: ', errors);
          });
      } else if (response.success) {
          c2.alerts.addGlobalAlert(response.success, 'success', true);
      }
      if (!response.table) {
          c2.spinners.hideSpinner({selector: '#report-container'});
      }
      $('button').prop('disabled', false);
  }

  window.c2.customReportCommon = {
    handleResponse: handleResponse,
    init: init,
    reloadFormOnAttrChange: reloadFormOnAttrChange,
    setupFieldStylesAndBehaviors:setupFieldStylesAndBehaviors
  };

})(window.c2, window.jQuery);
